import { Slideover } from "tailwindcss-stimulus-components";

export default class extends Slideover {}
